import angular from 'angular';
import paymentCartComponent from './payment-cart.component';
import paymentCartService from './payment-cart.service';
import paymentCartConfig from './payment-cart.config';


let paymentCartModule = angular.module('app.paymentCart',[])
.component('paymentCart', paymentCartComponent)
.service('PaymentCartService', paymentCartService)
.config(paymentCartConfig);
export default paymentCartModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-cart/payment-cart.js
 **/